import { Box, styled } from '@mui/material'

export const StyledMobileNav = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'scrollMargin'
})(({ theme, scrollMargin }) => ({
  '.menu-wrapper': {
    position: 'fixed',
    left: 0,
    width: '100%',
    height: `calc(100% - ${scrollMargin}px)`,   
    top: `${scrollMargin}px`,
    //background: 'white',
    overflow: 'auto',
    '.backdrop': {
      position: 'absolute',
      width: "100%",
      height: "100%",
      background: 'rgba(0,0,0,0.25)'
    }
	  
  },
}))
